/*
  TODO: Replace this with the returns_configuration_info template so that all
        default copy comes from a single source
*/

import { QTY_INPUT, QTY_WITH_EXPIRY_INPUT } from './fieldTypes';
import { EMAIL_MISMATCH, SAVE_SUCCESS } from './preferences';

export default {
  en: {
    // general
    'returns.general.skip_to_content': 'Skip to content',

    'returns.validate.form.zip.gift_label': 'Shipping Zip Code',
    'returns.item.qty_label': 'Quantity: ',
    'returns.item.expiry_date_label': 'Expiration date ',
    'returns.item.return_quantity_label': 'Return Quantity',
    'returns.item.return_date_label': 'Return Date: ',

    // Error Messages
    'returns.validate.session_timeout':
      'Your return submission was canceled after a long period of inactivity. Please re-enter your order information to begin your return again.',
    'returns.step_1.return_post_error_tooltip':
      'Unfortunately, we are unable to complete your return at this time. Please try again later.',
    'returns.validate.order_info_error_text':
      'We don’t seem to recognize that order number or zip code. Please double check and try again.',
    'returns.validate.order_info_gift_view_error_text':
      'We don’t seem to recognize that order number or zip code. Please double check and try again.',
    'returns.step_1.sidepanel_inventory_empty.exchange_only':
      'Unfortunately, this item is unavailable and cannot be exchanged at this time. Please check back later for exchange availability.',

    // Quantity Field
    [`returns.step_1.sidepanel_quantity_field.${QTY_INPUT}.qty.placeholder`]: 'Quantity',
    [`returns.step_1.sidepanel_quantity_field.${QTY_WITH_EXPIRY_INPUT}.subtitle`]:
      "Please also enter the product's expiration date to determine if it's eligible for return.",
    [`returns.step_1.sidepanel_quantity_field.${QTY_WITH_EXPIRY_INPUT}.qty.placeholder`]:
      'Quantity',
    [`returns.step_1.sidepanel_quantity_field.${QTY_WITH_EXPIRY_INPUT}.qty.validation_error`]:
      'This number exceeds the quantity eligible for returns.',
    [`returns.step_1.sidepanel_quantity_field.${QTY_WITH_EXPIRY_INPUT}.expiry.placeholder`]:
      'Date (MM/DD/YYYY)',
    [`returns.step_1.sidepanel_quantity_field.${QTY_WITH_EXPIRY_INPUT}.validate`]: 'VERIFY',
    [`returns.step_1.sidepanel_quantity_field.${QTY_WITH_EXPIRY_INPUT}.unavailable_error`]:
      'This date could not be verified. Please try again.',

    // Item Level Grouping
    'returns.step_1.item_level_grouping.title': 'Claimed Items:',
    'returns.step_1.item_level_grouping.items.closed.title': 'Not Eligible for Return or Exchange',
    'returns.step_1.item_level_grouping.items.initiated.title': 'Initiated Returns',
    'returns.step_1.item_level_grouping.my_returns.title': 'My Returns',
    'returns.step_1.item_level_grouping.my_returns.return.title': 'Return',
    'returns.step_1.item_level_grouping.my_returns.return.detail_field.return_status':
      'Return Status',
    'returns.step_1.item_level_grouping.my_returns.return.detail_field.estimated_refund':
      'Estimated Refund',
    'returns.step_1.item_level_grouping.my_returns.return.detail_field.order_number':
      'Order Number',
    'returns.step_1.item_level_grouping.my_returns.return.detail_field.rma_number': 'RMA Number',
    'returns.step_1.item_level_grouping.my_returns.return.detail_field.created_date':
      'Return Created Date',

    'returns.step_1.item_level_grouping.status.ITEM_STATUS_CLOSED': 'Return Closed',
    'returns.step_1.item_level_grouping.status.ITEM_STATUS_RECEIVED': 'Return Received',
    'returns.step_1.item_level_grouping.status.ITEM_STATUS_CREATED': 'Return Created',
    'returns.step_1.item_level_grouping.status.ITEM_STATUS_CLAIM_OPENED': 'A claim is open',
    'returns.step_1.item_level_grouping.status.ITEM_STATUS_CLAIM_APPROVED':
      'The claim for this item is approved',
    'returns.step_1.item_level_grouping.status.ITEM_STATUS_CLAIM_REJECTED':
      'The claim for this item is rejected',

    // Multi Order

    'returns.items.multi_item_form.user_query': 'Want to return other orders in the same box?',
    'returns.items.multi_item_form.enable_link': 'Check eligibility',
    'returns.items.multi_item_form.description':
      "Enter your order number to see if you're eligible to return multiple orders together.",
    'returns.items.multi_item_form.placeholder': 'Order Number',
    'returns.items.multi_item_form.submit': 'Submit',
    'returns.items.multi_item_form.existing_order_error':
      'This order has already been added. Please enter a different order number.',
    'returns.items.multi_item_form.over_limit_error':
      'The maximum amount of additional orders has been reached for this return.',

    // Defer Override

    'returns.step_1.sidepanel_defer_override.title': 'TELL US ABOUT YOUR RETURN',
    'returns.step_1.sidepanel_defer_override.button': 'Override Eligibility Rules',
    'returns.step_1.sidepanel_defer_override.error': 'An error occurred. Please try again.',

    // Photo Upload
    'returns.step_2.sidepanel_photo_upload_file_type_error':
      'File format is incorrect. Please upload a PNG, JPG, or HEIF.',
    'returns.step_2.sidepanel_photo_upload_file_size_error':
      'File is too big. Please re-upload an image with size less than 10 MB',
    'returns.step_2.sidepanel_photo_upload_file_limit_1_error':
      'Please upload a maximum of 1 image',
    'returns.step_2.sidepanel_photo_upload_file_limit_2_error':
      'Please upload a maximum of 2 images',
    'returns.step_2.sidepanel_photo_upload_general_error':
      'An error occurred while uploading files. Please try again.',

    // Printerless Info Page
    'returns.printerless_info_page.email_confirmation':
      'This mobile return code was sent via email to $email',
    'returns.printerless_info_page.email_secondary_link': 'Send to another email address',
    'returns.printerless_info_page.email_input_label': 'Email',
    'returns.printerless_info_page.email_secondary_send_button': 'SEND',
    'returns.printerless_info_page.email_secondary_confirmation':
      "Thanks! We'll also send a copy of the email to $email",
    'returns.printerless_info_page.location_header': 'Nearby $name Location',
    'returns.printerless_info_page.location.usps': 'USPS',
    'returns.printerless_info_page.location.ups': 'UPS',
    'returns.printerless_info_page.location.fedex': 'FedEx',
    'returns.printerless_info_page.location.nordstrom': 'Nordstrom',
    'returns.printerless_info_page.location.walgreens': 'Walgreens',
    'returns.printerless_info_page.item_quantity_header_format': '$itemQuantity Item(s) to Return',
    'returns.printerless_info_page.print_label_header':
      'Mobile pass not working or prefer to print the label yourself?',
    'returns.printerless_info_page.print_label_link': 'Get a print label for this return',
    'returns.printerless_info_page.itemSize': 'Size',
    'returns.printerless_info_page.itemColor': 'Color',
    'returns.printerless_info_page.itemStyle': 'Style #',
    'returns.printerless_info_page.returnQty': 'Quantity',

    // Shipping Address Sidepanel
    'returns.step_2.sidepanel_title': 'Your Shipping Address',
    'returns.step_2.sidepanel_question': 'What is your shipping address?',
    'returns.step_2.sidepanel_address': 'Done',
    'returns.step_2.sidepanel_address_validation_error':
      'Address Not Found. Please enter a valid address.',
    'returns.step_2.sidepanel_state': 'State',
    'returns.step_2.sidepanel_country': 'Country',

    // Shipping Address Form
    'returns.step_2.shipping_form_question': 'What is your shipping address?',
    'returns.step_2.shipping_form_address_validation_error':
      'Address Not Found. Please enter a valid address.',
    'returns.step_3.shipping_address': 'Shipping Address',

    // Async label
    'returns.step_async_label.header': 'We received your return request.',
    'returns.step_async_label.desc':
      'Your shipping label and the next steps for your return will be sent to {email}.',
    'returns.step_async_label.printerless_desc':
      'Your Mobile Return Code and the next steps for your return will be sent to {email}.',

    // Boxless
    'returns.return_options.boxless.title': 'Drop Off at UPS',
    'returns.return_options.boxless.subtitle': 'No box or label needed',
    'returns.return_options.boxless.description':
      'Bring your unpackaged items to a nearby UPS and a store associate will pack and return it for you',
    'returns.stripe_card_title': 'Enter your card details',
    'returns.stripe_card_submit_button': 'Next',
    'returns.stripe_card_number_title': 'Credit or Debit card',
    'returns.stripe_card_expiry_title': 'MM / YY',
    'returns.stripe_card_cvc_title': 'CVC',
    'returns.stripe_card_number_placeholder': 'Card Number',
    'returns.stripe_card_expiry_placeholder': 'MM / YY',
    'returns.stripe_card_cvc_placeholder': 'CVC',
    'returns.general.service_fee': 'Convenience Fee',
    'returns.stripe_terms_and_conditions':
      'There is a {fee} fee for this service. You will not be charged until your return is dropped off at The UPS Store.',
    'returns.stripe_fee': 'Paid by card',
    'returns.stripe_fee_description': 'UPS Drop-Off Service Fee**',
    'returns.stripe_title': 'UPS Convenience Fee',
    'returns.stripe_subtitle':
      'There is a {fee} fee for this service. You will not be charged until your return is dropped off at The UPS Store.',
    'returns.step_3_payment_title': 'UPS Convenience Fee',
    'returns.step_3_payment_summary_key': 'Card will be charged at drop-off',
    'returns.instruction[0].boxless_ups': 'Bring your return to The UPS store',
    'returns.instruction[0].description_boxless_ups':
      "Bring your return items to your selected UPS location. Don't worry about packing up your items, we'll do that at the store for you.",
    'returns.instruction[1].boxless_ups': 'Show your Mobile Return Code',
    'returns.instruction[1].description_boxless_ups':
      'An associate will scan your code and take care of your return items.',
    'returns.instruction[1].button_boxless_ups': 'GET MOBILE RETURN CODE',
    'returns.instruction.return_loop_description': 'Need to return more items?',
    'returns.instruction.return_loop_link_text': 'Start Another Return',
    'returns.boxless_info_page.email_confirmation':
      'This UPS Mobile Return Code was sent via email to $email',
    'returns.boxless_info_page.email_secondary_link': 'Send to another email address',
    'returns.boxless_info_page.email_input_label': 'Email',
    'returns.boxless_info_page.email_secondary_send_button': 'SEND',
    'returns.boxless_info_page.email_secondary_confirmation':
      "Thanks! We'll also send a copy of the email to $email",
    'returns.boxless_info_page.location_header': 'Selected UPS Location',
    'returns.boxless_info_page.item_quantity_header_format': '$itemQuantity Item(s) to Return',
    'returns.boxless_info_page.print_label_header': 'Prefer to pack and print on your own?',
    'returns.boxless_info_page.print_label_subheader':
      "If you change your mind or your mobile pass isn't working, you can always print your label instead",
    'returns.boxless_info_page.print_label_link': 'Get a print label for this return',

    // Local Pickup
    'returns.return_options.local_pickup.learn_more.link_text': 'Learn More about Courier Pickup',
    'returns.return_options.local_pickup.learn_more.title': 'Courier Pickup',
    'returns.return_options.local_pickup.learn_more.section[0].title': 'Select a time window',
    'returns.return_options.local_pickup.learn_more.section[0].description':
      'A courier will pick up your items on the next available day.*',
    'returns.return_options.local_pickup.learn_more.section[1].title':
      'Hand your items to the courier',
    'returns.return_options.local_pickup.learn_more.section[1].description':
      'Just have your return ready, no packaging or printing needed.',
    'returns.return_options.local_pickup.learn_more.section[2].title': 'Receive your refund',
    'returns.return_options.local_pickup.learn_more.section[2].description':
      'Your return will be processed by a nearby store within 24 hours.',
    'returns.return_options.local_pickup.learn_more.button_text': 'SELECT',
    'returns.return_options.local_pickup.learn_more.disclaimer':
      '*You will receive a two-hour pickup window on the morning of your pickup. The Courier Pickup service is available Monday to Friday in select ZIP Codes.',
    'returns.local_pickup_tforce.pickup.title': 'Pickup Information',
    'returns.local_pickup_tforce.pickup.location.title': 'Pickup Location',
    'returns.local_pickup_tforce.pickup.location.subtitle':
      'This is the original delivery address and cannot be edited.',
    'returns.local_pickup_tforce.pickup.instructions.button': 'Add Pickup Instructions',
    'returns.local_pickup_tforce.pickup.instructions.required': '(Required)',
    'returns.local_pickup_tforce.pickup.instructions.placeholder':
      'Take the lobby elevator up to the 3rd floor.',
    'returns.local_pickup_tforce.pickup.timeslots.error':
      'It looks like there aren’t any pickup times available. Please select another return method or try again later.',
    'returns.local_pickup_tforce.pickup.timeslots.title': 'Pickup Time',
    'returns.local_pickup_tforce.pickup.timeslots.description':
      'The next available pickup will be ',
    'returns.step_3.local_pickup_tforce': 'Courier Pickup',
    'returns.step_3.local_pickup.title': 'Pickup Details',
    'returns.step_3.local_pickup.edit_button': 'Edit',
    'returns.step_3.local_pickup.time_label': 'Time',
    'returns.step_3.local_pickup.address_label': 'Address',
    'returns.step_3.local_pickup.instructions_label': 'Instructions',
    'returns.step_4.header.local_pickup_tforce': 'Get Ready for Your Pickup',
    'returns.step_4.return_instructions_header.local_pickup_tforce': 'Pickup Instructions',
    'returns.instruction[0].local_pickup_tforce': 'Gather your return items for pickup',
    'returns.instruction[0].description_local_pickup_tforce':
      'Make sure you’ve got your return items handy. Don’t worry about packing them up or printing a label, the courier will do that at pickup.',
    'returns.instruction[1].local_pickup_tforce': 'Keep an eye out for a 2-hour pickup window',
    'returns.instruction[1].description_local_pickup_tforce':
      'On the morning of your pickup, we’ll email you an update with your 2-hour window once your courier is scheduled.',
    'returns.instruction[1].pickup_label_local_pickup_tforce': 'Pickup time:',
    'returns.step_1.cancel_return_modal.local_pickup.title':
      'Are you sure you want to cancel your courier pickup?',
    'returns.step_1.cancel_return_modal.local_pickup.description':
      'Cancelling your pickup cannot be undone.',
    'returns.step_1.cancel_return_modal.local_pickup.confirm_button': 'CANCEL PICKUP',
    'returns.step_1.cancel_return_modal.local_pickup.back_button': 'NEVERMIND',
    'returns.step_1.local_pickup.cancel_return_btn': 'Cancel Pickup',

    // FAQ
    'returns.faq.local_pickup.title': 'Frequently Asked Questions',
    'returns.faq.local_pickup.sections[0].title': 'How does the Courier Pickup Service work?',
    'returns.faq.local_pickup.sections[0].description':
      'Simply hand your return items to the courier on your selected pickup time and receive your refund within 24 hours.',
    'returns.faq.local_pickup.sections[1].title': 'Where and when is Courier Pickup available?',
    'returns.faq.local_pickup.sections[1].description':
      'The Courier Pickup service is available Monday to Friday in select ZIP codes.',
    'returns.faq.local_pickup.sections[2].title': 'When will the courier pick up my return?',
    'returns.faq.local_pickup.sections[2].description':
      'The courier will arrive within the pickup window you selected. On the morning of your pickup, a more specific two-hour time window will be emailed to you once your courier is confirmed.',
    'returns.faq.local_pickup.sections[3].title':
      'My courier did not pick up my return. What should I do?',
    'returns.faq.local_pickup.sections[3].description':
      "Email us at <a href='mailto:returns_claims@narvar.com'>returns_claims@narvar.com</a> to resolve this issue.",
    'returns.faq.local_pickup.sections[4].title': 'When will I get my refund?',
    'returns.faq.local_pickup.sections[4].description':
      'Once the courier drops off your return at our store, we will process your return within one business day.',
    'returns.faq.local_pickup.sections[5].title': 'Can I cancel my pickup?',
    'returns.faq.local_pickup.sections[5].description':
      'You will have until 10PM the night before your pickup to cancel. To cancel, please log into your returns portal.',
    'returns.faq.local_pickup.sections[6].title': 'What happens if I miss my pickup?',
    'returns.faq.local_pickup.sections[6].description':
      "Email <a href='mailto:returns_claims@narvar.com'>returns_claims@narvar.com</a> to coordinate a new pickup time.",
    'returns.faq.local_pickup.sections[7].title': 'Can I change my pickup address?',
    'returns.faq.local_pickup.sections[7].description':
      'No, your pickup address cannot be changed.',

    'returns.step_3.drop_off_details.title': 'Drop-Off Details',
    'returns.step_3.drop_off_details.buttons.edit': 'Edit',
    'returns.step_3.drop_off_details.labels.location': 'Location',
    'returns.step_3.drop_off_details.labels.address': 'Address',

    // Pickup Upgrade
    'returns.addons.pickups.call_to_action.header': 'Home Pickup',
    'returns.addons.pickups.call_to_action.subheader': 'Want us to pick up your return instead?',
    'returns.addons.pickups.call_to_action.body':
      'A courier will pick up your package the next available day for a small fee - no need to be home.',
    'returns.addons.pickups.call_to_action.confirm': 'CONTINUE',
    'returns.addons.pickups.call_to_action.cancel': 'No thanks',

    'returns.addons.pickups.call_to_action.subheader.v1': 'Want us to pick up your return instead?',
    'returns.addons.pickups.call_to_action.body.v1':
      'Save time by having a courier pick up your package.',
    'returns.addons.pickups.call_to_action.confirm.v1': 'SCHEDULE PICKUP',

    'returns.addons.pickups.call_to_action.subheader.v2': 'Want us to pick up your return instead?',
    'returns.addons.pickups.call_to_action.body.v2':
      'Save time by having a courier pick up your package for an additional fee.',
    'returns.addons.pickups.call_to_action.confirm.v2': 'SCHEDULE PICKUP',

    'returns.addons.pickups.call_to_action.subheader.v3': 'Want us to pick up your return instead?',
    'returns.addons.pickups.call_to_action.body.v3':
      'Save time by having a courier pick up your package.',
    'returns.addons.pickups.call_to_action.confirm.v3': 'LEARN MORE',

    'returns.pickups_page.title': 'Home Pickup',
    'returns.pickups_page.description':
      'Have your package picked up the next available day - no need to be home.',
    'returns.pickups_page.help_url': 'https://corp.narvar.com/home-pickup-consumer#howitworks',
    'returns.pickups_page.help_url_text': 'How Home Pickup Works',
    'returns.pickups_page.time.title': 'Pickup Date',
    'returns.pickups_page.time.subtitle': 'We can pick up Monday-Friday, excluding holidays.',
    'returns.pickups_page.time.footer': 'The pickup window will be from 9AM to 4PM.',
    'returns.pickups_page.tomorrow': 'Tomorrow, ',
    'returns.pickups_page.address.title': 'Pickup Details',
    'returns.pickups_page.address.subtitle':
      'Returns can only be picked up from the original delivery address.',
    'returns.pickups_page.pickup_types.title': 'How will the courier pick up your package?',
    'returns.pickups_page.pickup_types.unattended': 'Contactless',
    'returns.pickups_page.pickup_types.in-person': 'Direct Handoff',
    'returns.pickups_page.pickup_types.front desk': 'At Front Desk',
    'returns.pickups_page.instructions.button': 'Add Pickup Instructions',
    'returns.pickups_page.instructions.required': '(Required)',
    'returns.pickups_page.instructions.placeholder':
      'Enter the code 0348 to call me or 000 for the front desk.',
    'returns.pickups_page.success.header': 'Home Pickup',
    'returns.pickups_page.email_confirmation.header': 'Your Pickup is Confirmed.',
    'returns.pickups_page.email_confirmation.description': 'A confirmation email has been sent to ',
    'returns.pickups_page.instructions.header': 'Next steps for your pickup',
    'returns.pickups_page.instructions[1].header': 'Print your return shipping label',
    'returns.pickups_page.instructions[1].button': 'PRINT SHIPPING LABEL',
    'returns.pickups_page.instructions[2].header': 'Pack up your items',
    'returns.pickups_page.instructions[2].description':
      'Place your packing slip and items in the original or new package, and seal it. Mark out any old addresses and barcodes, then attach your return shipping label.',
    'returns.pickups_page.instructions[3].header': 'Prepare for your courier pickup',
    'returns.pickups_page.instructions[3].description':
      'The pickup window will be from 9AM to 4PM. Hand your package to the courier or place it in a safe location for pickup.',
    'returns.pickups_page.instructions[3].time_window':
      'The pickup window will be from {from} to {to}. Hand your package to the courier or place it in a safe location for pickup.',
    'returns.pickups_page.error.not_eligible.title':
      'This return is not eligible for pickup at this time.',
    'returns.pickups_page.error.not_eligible.description':
      'To complete your return, please drop off your package at a nearby carrier location.',
    'returns.pickups_page.error.submit_failure.description':
      'We are unable to submit your pickup request at this time. Please refresh the page or try again later.',
    'returns.pickups_page.submit_button': 'SUBMIT',

    'returns.stripe.pickups.title': '{fee} Pickup Convenience Fee',
    'returns.stripe.pickups.subtitle':
      'This is a non-refundable fee* in addition to any return shipping fees deducted from your return. Once the pickup is scheduled, it cannot be canceled.',
    'returns.stripe.pickups.card_title': 'Enter your card details',
    'returns.stripe.pickups.card_number_placeholder': 'Card Number',
    'returns.stripe.pickups.card_expiry_placeholder': 'MM/YY',
    'returns.stripe.pickups.card_cvc_placeholder': 'CVC',
    'returns.stripe.pickups.card_submit_button': 'SUBMIT',
    'returns.stripe.pickups.footnote':
      '*Charges will appear on your credit card statement as Narvar*{retailer}',

    'returns.pickups_page.pickup_policy.title': 'Pickup Policy',
    'returns.pickups_page.pickup_policy.description':
      'Your return package must weigh less than 10 lbs and measure less than 18 inches on any side. Bulky items will not be accepted. The courier may decline packages that do not qualify.',
    'returns.pickups_page.pickup_policy.checkbox_label': 'Yes, I agree with this pickup policy',
    'returns.pickups_page.pickup_cta.title': 'Schedule a Home Pickup',
    'returns.pickups_page.pickup_cta.description':
      "Choose a date and we'll schedule a courier to pick up your return.",
    'returns.pickups_page.pickup_cta.learn_more': 'Learn more',
    'returns.pickups_page.pickup_cta.badge': 'NEW',

    'returns.home_pickup.details_form.title': 'Provide us with a few more details',
    'returns.home_pickup.details_form.pickup_types.title':
      'How will the courier pickup your package?',
    'returns.home_pickup.details_form.instructions.title': 'Pickup Instructions',
    'returns.home_pickup.details_form.instructions.placeholder':
      'Enter the code 0348 to call me or 000 for the front desk.',
    'returns.home_pickup.details_form.submit': 'Submit',

    'returns.pickups_page.phone_number_form.header': 'Get Text Updates About Your Pickup',
    'returns.pickups_page.phone_number_form.header_tag': '(optional)',
    'returns.pickups_page.phone_number_form.placeholder': '(555) 555-5555',
    'returns.pickups_page.phone_number_form.footer':
      'By entering your mobile number, you consent to calls or texts from the courier for this pickup. Message & data rates apply.',
    'returns.pickups_page.phone_number_form.error': 'Please enter a valid mobile phone number.',

    'pudo.pudo_list.fee.label.label_fee': 'Label Fee',
    'pudo.pudo_list.fee.label.shipping_fee': 'Shipping Fee',
    'pudo.pudo_list.fee.label.pickup_fee': 'Pickup Fee',
    'pudo.home_pickup.time_slot.title': 'We can pick up your return',
    'pudo.home_pickup.time_slot.description':
      'The pickup window will be from {{earliestHour}} to {{latestHour}}.  <br/>' +
      'Hand your package directly to courier or leave your package in a safe place for pickup.',
    'pudo.home_pickup.pickup_location.title': 'Pickup Location',
    'pudo.home_pickup.pickup_location.description':
      'Returns can only be picked up from the original delivery address.',
    'pudo.home_pickup.pickup_instructions.toggle_title': 'Add Pickup Instructions',
    'pudo.home_pickup.pickup_fee.title': '{{pickup_fee}} Pickup Convenience Fee', // eslint-disable-line no-template-curly-in-string
    'pudo.home_pickup.pickup_fee.description':
      'This is a non-refundable fee in addition to any return shipping fees deducted from your return. <br/> Once the pickup is scheduled, it cannot be canceled.',
    'pudo.home_pickup.pickup_instructions.placeholder':
      'Take the lobby elevator up to the 3rd floor.',
    'pudo.home_pickup.pickup_instructions.handoff.title':
      'How will the courier pick up your package?',
    'pudo.error.no_timeslots':
      'No available pickup timeslots. Please go back and choose a different return method.',

    'returns.return_options.drop_off.title': 'Drop Off Nearby',
    'returns.return_options.drop_off.description':
      'Drop off using a printerless QR code or a printed label.',
    'returns.return_options.drop_off.multi_fee_label': 'Varies',
    'returns.return_options.locations.show_more': 'Show more drop-off locations',
    'returns.return_options.locations.show_less': 'Show less drop-off locations',
    'returns.return_options.locations.self.method_price_label': 'Fee varies by carrier',
    'returns.return_options.locations.printerless_mail.instructions': `No printer, no problem. Show the associate your return code and they'll print the label for you.`,
    'returns.return_options.locations.boxless.instructions':
      'No box, no problem. Show the associate your return code and they will pack your item and print the label.',
    'returns.return_options.locations.mail.instructions':
      'Print your label and mail your package back to us.',
    'returns.return_options.locations.concierge.instructions':
      'Print your label and mail your package back to us.',

    // Localized shipping address form
    'address_form.input.customer_name': 'Name',
    'address_form.input.first_name': 'First Name',
    'address_form.input.last_name': 'Last Name',
    'address_form.input.company_name': 'Company Name',
    'address_form.input.address_line1': 'Street Address',
    'address_form.input.address_line2': 'Apt/Suite',
    'address_form.input.postal_code': 'Zip Code',
    'address_form.input.city': 'City',
    'address_form.input.province': 'State',
    'address_form.input.country': 'Country',

    'returns.carrier_pickup.pickup_ups.pickup_location.title': 'Pickup Location',
    'returns.carrier_pickup.pickup_ups.pickup_location.button_edit': 'Edit',
    'returns.carrier_pickup.pickup_ups.pickup_location.button_save': 'Save',
    'returns.carrier_pickup.pickup_ups.pickup_location.button_cancel': 'Cancel',
    'returns.carrier_pickup.pickup_ups.pickup_date.title': 'Pickup Date',
    'returns.carrier_pickup.pickup_ups.pickup_date.description':
      'Pickups will take place between 10AM and 4PM local time.',
    'returns.carrier_pickup.pickup_ups.pickup_date.no_dates':
      "It looks like there aren't any pickup dates available. Please select another return method or try again later.",

    'returns.step_3.carrier_pickup.pickup_ups.pickup_details.title': 'Pickup Details',
    'returns.step_3.carrier_pickup.pickup_ups.pickup_details.date_label': 'Date',
    'returns.step_3.carrier_pickup.pickup_ups.pickup_details.address_label': 'Address',

    // Digital
    'returns.step_3.digital': 'Digital',
    'returns.return_options.digital.title': 'Digital Item',
    'returns.return_options.digital.subtitle': '',
    'returns.return_options.digital.description': 'This return contains only digital items.',
    'returns.return_options.digital.store_link': '',
    'returns.return_options.digital.store_link_text': '',

    // User Preferences - Return Method
    'returns.step_3.preferences.description':
      'I want to save my returns methods & preferences to use for future returns with retailers who use Narvar. I agree to the <a target="_blank" href="https://corp.narvar.com/profile-terms-of-service">terms of service</a> and <a target="_blank" href="https://corp.narvar.com/privacy-policy#consumer-annex">privacy policy</a>. I can add, update, or delete my preferences at any time.',
    'returns.step_3.preferences.email_description':
      'Confirm the email address you would like to associate your preference with.',
    'returns.step_3.preferences.email_placeholder': 'Email Address',
    [`returns.step_3.preferences.${EMAIL_MISMATCH}.description`]: `Unable to validate your email. Please try again or submit without saving your preferences by unchecking the box above.`,
    [`returns.step_4.preferences.${SAVE_SUCCESS}.description`]:
      'Your return preferences have been saved.  Complete your profile to apply them to future returns.',
    [`returns.step_4.preferences.${SAVE_SUCCESS}.link_text`]: 'Complete profile',
    'returns.step_4.preferences.update.description':
      'Save your return preferences to use for future returns with retailers who use Narvar.',
    'returns.step_4.preferences.update.link_text': 'Update preferences',
    'returns.step_4.preferences.manage.description': `You've previously saved your return preferences.`,
    'returns.step_4.preferences.manage.link_text': 'Manage your preferences',
    'returns.step_2.preferences.description': 'Your return preferences have been applied.',
    'returns.step_2.preferences.link_text': 'Manage your preferences',

    'returns.step_1.sidepanel_exchange_reason_title': 'Why do you want to exchange this item?',
    'returns.step_1.sidepanel_exchange_additional_comments_mandatory':
      'Reason for exchange (required):',
    'returns.step_1.sidepanel_exchange_additional_comments': 'Additional comments (optional):',

    // Attestation
    'returns.step_3.attestation.description': 'Type your full name below to use as your signature.',
    'returns.step_3.attestation.field.full_name': 'Full Name',
    'returns.step_3.attestation.field.first_name': 'First Name',
    'returns.step_3.attestation.field.last_name': 'Last Name',
    'returns.step_3.attestation.field.title': 'Job Title',

    // Review Page Claims

    'returns.step_3.step_3_header.claim': 'Summary',
    'returns.step_3.summary_header.claim': 'We will review the following items',

    // Signature Attestation

    'step_3.signature_attestation.title':
      'Please submit true and accurate information in your claim',
    'step_3.signature_attestation.description':
      '<ul>' +
      '<li>I certify that this is the only request I am filing for this loss with $retailerName.</li>' +
      '<li>I confirm that all information is true, accurate, and authentic. I have not knowingly provided false information.</li>' +
      '<li>I agree to contact $retailerName. to report items that have arrived after filing a request for lost or stolen items.</li>' +
      '</ul>',
    'step_3.signature_attestation.signature_header':
      'Type your full name below to use as your signature',
    'step_3.signature_attestation.placeholder': 'Signature',
    'step_3.signature_attestation.checkbox_text':
      'I certify that the information I am submitting is accurate and that I agree to the Terms and Conditions and Privacy Policy.',
    'step_3.claim_post_error_tooltip':
      'Unfortunately, we are unable to complete your claim at this time. Please try again later.',

    'returns.onboarding.banner.description':
      'You are viewing a demo of your returns experience. To complete your setup, $publishLink',
    'returns.onboarding.banner.publish_link': 'publish your settings.',

    'returns.step_1.item_sidepanel_title': 'TELL US ABOUT YOUR ITEM',
    'returns.step_1.item_sidepanel_product_choice': 'What would you like to do?',
    'returns.step_1.item_sidepanel_product.return': 'Return this item',
    'returns.step_1.item_sidepanel_product.exchange': 'Exchange this item',
    'returns.step_1.item_sidepanel_product.claim': 'Report this item as missing',

    'returns.step_1.item_sidepanel_product.claim.MIXED_CART_MESSAGE_TOKEN':
      'A $product process has already begun. To initiate a claim, please complete the $product or remove the $product process first.',
    'returns.step_1.item_sidepanel_product.no_actions':
      'There are no actions available for this item.',
    'returns.step_1.item_sidepanel_product.no_reasons':
      'There are no actions available for this item.',

    'returns.step_1.item_sidepanel_product.exchange.MIXED_CART_MESSAGE_TOKEN':
      'A claim process has already begun. To initiate an exchange, please complete or remove the claim process first.',
    'returns.step_1.item_sidepanel_product.return.MIXED_CART_MESSAGE_TOKEN':
      'A claim process has already begun. To initiate a return, please complete or remove the claim process first.',

    'returns.step_1.item_sidepanel.claim.reason_title': 'Can you tell us more?',
    'returns.step_1.item_sidepanel.claim.quantity': 'How many?',
    'returns.step_1.item_sidepanel.claim.comments_title': 'Additional Comments',
    'returns.step_1.item_sidepanel.claim.comments_optional':
      'Anything else you would like to share? (optional)',
    'returns.step_1.item_sidepanel.claim.comments_mandatory':
      'Anything else you would like to share? (required)',
    'returns.step_1.item_sidepanel.claim.attestation_label':
      'I confirm I have checked the areas surrounding my front door, mailbox, and have waited at least 3 days.',
    'returns.step_1.item_sidepanel.claim.remove_item': 'REMOVE ITEM',
    'returns.item.claim_label': 'Reason:',
    'returns.step_4.header.claim': 'We will review your request!',
    'returns.step_4.email_confirmation.claim':
      'We’ve sent a confirmation email to $email. We will review the information you provided and get back to you with next steps soon.',
    'returns.instruction.claim_loop_description': 'Need help with other items?',
    'returns.instruction.claim_loop_link_text': 'Get started here',
    'step_1.item_selection_header': 'Which items can we help you with?',
    'step_1.item_selection_header.additional_missing_items':
      'Were any other items missing from your order?',

    'narvar_app_cta.title': 'Don’t dig around for return labels anymore.',
    'narvar_app_cta.subtitle': 'Get the Narvar App',

    'returns.step_1.sidepanel_uneven_exchange_title':
      'Would you like to exchange for something else?',
    'returns.step_1.sidepanel_uneven_exchange_next': 'Next',
    'returns.step_1.sidepanel_uneven_exchange_back': 'Back',
    'returns.step_1.sidepanel_uneven_exchange_in_stock': 'In Stock',
    'returns.step_1.sidepanel_uneven_exchange_out_of_stock': 'Out of Stock',
    'returns.step_3.amount_due_label': 'Amount Due',
    'returns.step_3.uneven_exchange_summary_return_header': 'You are returning',
    'returns.step_3.uneven_exchange_summary_exchange_header': 'You are receiving',
    'returns.step_3.exchange_payment_form.title': 'Payment Information',
    'returns.step_3.exchange_payment_form.text': '',
    'returns.step_3.exchange_payment_form.card_number.label': 'Card Number',
    'returns.step_3.exchange_payment_form.expiry.label': 'MM / YY',
    'returns.step_3.exchange_payment_form.cvc.label': 'CVC',

    'returns.step_3.resolution.resolution_label': 'How would you like your issue resolved?',
    'returns.step_3.resolution.refund_label': 'How would you like to receive your refund?',

    'returns.bundle.free_gift': 'Free gift must be returned if the qualifying item is returned',
    'returns.bundle.bundle_below_min_value':
      'Item must be returned if order amount goes below {{bundle_min_value}}{{currency}}',
  },
};
